export default __webpack_public_path__ + "static/media/news24022910.515986c9.png";